import React, { Component } from "react";
import { Route, Switch, BrowserRouter, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import Home from "../pages/home/HomeComponent";
import Splash from "../pages/splash/Splash";
import Education from "../pages/education/EducationComponent";
import Experience from "../pages/experience/Experience";
import Contact from "../pages/contact/ContactComponent";
import Projects from "../pages/projects/Projects";
import ProjectDetail from "../pages/projectDetail/ProjectDetail";
import { settings } from "../portfolio.js";
import Error404 from "../pages/errors/error404/Error";
import FloatingNavbar from "../components/floatingNavbar/FloatingNavbar";
import Chatbot from "../components/chatbot/Chatbot";

const SITE_URL = "https://ghassenbennasser.com";

// Emits a self-referencing canonical for each route on the apex host
// (ghassenbennasser.com), which is the primary domain — www 307-redirects
// to it, so the canonical must point at the apex, not www.
// Done per-route rather than statically in index.html so SPA subpages
// (/experience, /projects, ...) don't all get marked as duplicates of "/".
const CanonicalTag = withRouter(({ location }) => (
  <Helmet>
    <link rel="canonical" href={`${SITE_URL}${location.pathname}`} />
  </Helmet>
));

export default class Main extends Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <>
          <CanonicalTag />
          <FloatingNavbar theme={this.props.theme} />
          <Chatbot theme={this.props.theme} />
          <Switch>
            <Route
              path="/"
              exact
              render={(props) =>
                settings.isSplash ? (
                  <Splash {...props} theme={this.props.theme} />
                ) : (
                  <Home {...props} theme={this.props.theme} />
                )
              }
            />
            <Route
              path="/home"
              render={(props) => <Home {...props} theme={this.props.theme} />}
            />
            <Route
              path="/experience"
              exact
              render={(props) => (
                <Experience {...props} theme={this.props.theme} />
              )}
            />
            <Route
              path="/education"
              render={(props) => (
                <Education {...props} theme={this.props.theme} />
              )}
            />
            {/* <Route
              path="/opensource"
              render={(props) => (
                <Opensource {...props} theme={this.props.theme} />
              )}
            /> */}
            <Route
              path="/contact"
              render={(props) => (
                <Contact {...props} theme={this.props.theme} />
              )}
            />

            {settings.isSplash && (
              <Route
                path="/splash"
                render={(props) => (
                  <Splash {...props} theme={this.props.theme} />
                )}
              />
            )}

            <Route
              path="/projects"
              exact
              render={(props) => (
                <Projects {...props} theme={this.props.theme} />
              )}
            />
            <Route
              path="/projects/:id"
              render={(props) => (
                <ProjectDetail {...props} theme={this.props.theme} />
              )}
            />
            <Route
              path="*"
              render={(props) => (
                <Error404 {...props} theme={this.props.theme} />
              )}
            />
          </Switch>
        </>
      </BrowserRouter>
    );
  }
}
